import request from '@/utils/request'

export function userSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/user/userSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addUser(data) {
    return request({
        url: `api/serviceCenter/user/addUser`,
        method: 'post',
        data,
    })
}

export function upDateUser(data) {
    return request({
        url: `api/serviceCenter/user/upDateUser`,
        method: 'post',
        data,
    })
}

export function bathDeleteUser(data) {
    return request({
        url: `api/serviceCenter/user/bathDeleteUser`,
        method: 'post',
        data,
    })
}






